// import { Dialog } from '@mui/material';
import { Modal, ModalBody } from "reactstrap";
import React, { useEffect } from 'react';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import SelectPaymentMode from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/SelectPaymentMode";
import moment from "moment";
import { paymentMode } from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";
import { paymentMoodeHeading } from "./constant";


const ViewDetailPaymentModeDialog = ({ isOpen, setOpen, crossClickHandler, contextValue,rowData,isReceipt,isView=true }) => {
    const {currentPaymentMode}=contextValue
    const SelectedPaymentMode= paymentMode?.[currentPaymentMode];

    return (
        <Modal
            isOpen={isOpen}
            style={{ maxWidth: '900px', width: '100%' }}
            size="xl"
            centered={true}
        >
            <ModalBody className='p-4'>
                <div className='d-flex justify-content-between'>
                    <h2>{paymentMoodeHeading?.[rowData?.paymentMode]}</h2>
                <CrossIcon onClick={crossClickHandler} />
                </div>
                {/* <SelectPaymentMode contextValue={contextValue} isReceipt={isReceipt} isView={true}/> */}
              <SelectedPaymentMode contextValue={contextValue} isView={true}/>
            </ModalBody>
        </Modal>
    );
}

export default ViewDetailPaymentModeDialog;